<template>
  <DsShowcase title="BadgePlay" description="Badge/label com estados semânticos, tamanhos e cores customizáveis.">
    <!-- PROP: state -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">state</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'default' | 'danger' | 'warning' | 'success'</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <BadgePlay text="Default" state="default" />
        <BadgePlay text="Danger" state="danger" />
        <BadgePlay text="Warning" state="warning" />
        <BadgePlay text="Success" state="success" />
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'xxs' | 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl'</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <BadgePlay text="xxs" size="xxs" state="success" />
        <BadgePlay text="xs" size="xs" state="success" />
        <BadgePlay text="sm" size="sm" state="success" />
        <BadgePlay text="base" size="base" state="success" />
        <BadgePlay text="lg" size="lg" state="success" />
        <BadgePlay text="xl" size="xl" state="success" />
      </div>
    </section>

    <!-- PROP: weight -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">weight</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'normal' | 'medium' | 'semibold' | 'bold'</code> — padrão: <code>semibold</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <BadgePlay text="Normal" weight="normal" state="warning" />
        <BadgePlay text="Medium" weight="medium" state="warning" />
        <BadgePlay text="Semibold" weight="semibold" state="warning" />
        <BadgePlay text="Bold" weight="bold" state="warning" />
      </div>
    </section>

    <!-- PROP: color / bgColor -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">color / bgColor</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — cores customizadas (sobrescrevem state)</p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <BadgePlay text="Custom roxo" color="#7c3aed" bg-color="#ede9fe" />
        <BadgePlay text="Custom azul" color="#1e40af" bg-color="#dbeafe" />
        <BadgePlay text="Custom rosa" color="#be185d" bg-color="#fce7f3" />
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:items-center tw:gap-4 tw:flex-wrap">
        <BadgePlay text="Loading..." :skeleton="true" />
        <BadgePlay text="Loading..." :skeleton="true" size="lg" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import DsShowcase from '../DsShowcase.vue'
import { BadgePlay } from '@/components/atomic'
</script>
